<div class="content">
  <div class="title-div">
    <div class="orders-title">
      <span class="heading-left">Master Schedule</span>
    </div>
  </div>

  <project-filters [filterSettings]="filterSettings" (filterSettingsChanged)="updateProjects()">
  </project-filters>

  <div class="single-calendar">
    <master-schedule-calendar 
      [activityName]="filterSettings.activity" 
      [filterSettings]="filterSettings" 
      [lastUpdated]="filterSettingsLastUpdated"
      [initialZoomLevel]="0.8"
      [updateProjects]="updateProjectsCallback"></master-schedule-calendar>
  </div>
</div>
